import { pickBy, negate, isEmpty } from 'lodash-es';

const isNotEmpty = negate(isEmpty);

export function createQueryStringUrl(url, query = {}) {
  const compactQuery = pickBy(query, isNotEmpty);
  const compactQueryIsEmpty = isEmpty(compactQuery);

  return compactQueryIsEmpty
    ? url
    : `${url}?` +
        Object.keys(compactQuery)
          .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(compactQuery[key])}`)
          .join('&');
}

/**
 * From JQuery param
 * Example:
 *   > hash = {a: 1, b: {c: 2}, d: [3, 4]}
 *      Object { a: 1, b: { c: 2 } }
 *   > coverQueryString(hash)
 *      "a=1&b%5Bc%5D=2&d%5B%5D=3&d%5B%5D=4"
 *    unescape: "a=1&b[c]=2&d[]=3&d[]=4"
 */
export function coverQueryString(a) {
  const s = [];
  const add = function (k, v) {
    v = typeof v === 'function' ? v() : v;
    v = v === null ? '' : v === undefined ? '' : v;
    s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
  };
  const buildParams = function (prefix, obj) {
    let i, len, key;

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          buildParams(prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']', obj[i]);
        }
      } else if (Object.prototype.toString.call(obj) === '[object Object]') {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key]);
        }
      } else {
        add(prefix, obj);
      }
    } else if (Array.isArray(obj)) {
      for (i = 0, len = obj.length; i < len; i++) {
        add(obj[i].name, obj[i].value);
      }
    } else {
      for (key in obj) {
        buildParams(key, obj[key]);
      }
    }

    return s;
  };

  return buildParams('', a).join('&');
}

export function createQueryStringFromArray(key, array = []) {
  const urlParams = new URLSearchParams();

  for (const value of array) {
    urlParams.append(key, value);
  }

  return urlParams.toString();
}
